<template>
  <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-show="open" :class="{show: open}">
    <div class="cstm-modal">
      <div class="header">
        <h3>Edit Class Details</h3>
        <button @click="closeModal" class="close-modal">&times;</button>
      </div>
        
      <div class="p-4 modal-content">
        <div class="flex flex-1 flex-wrap">
          <div class="md:w-1/2 w-full p-1">
            <vs-input
              class="w-full"
              placeholder="Enter class Name"
              v-model="class_name"
            />
          </div>

          <div class="md:w-1/2 w-full p-1">
            <vs-input
              class="w-full"
              placeholder="Enter class Capacity"
              v-model="class_capacity"
            />
          </div>

          <div class="md:w-1/2 w-full p-1">
            <flat-pickr
              class="w-full"
              placeholder="Enter class Start Date"
              v-model="class_start_date"
              :config="fpConfig"
            />
          </div>

          <div class="md:w-1/2 w-full p-1">
            <flat-pickr
              class="w-full"
              placeholder="Enter class End Date"
              v-model="class_end_date"
              :config="fpConfig"
            />
          </div>

          <div class="md:w-1/2 w-full p-1">
            <vs-input
              class="w-full"
              placeholder="Enter Term"
              v-model="term"
            />
          </div>

          <div class="md:w-1/2 w-full p-1">
            <v-select
              class="w-full"
              placeholder="Set Holidays"
              multiple
              v-model="holidays"
              :options="holiday_list"
              label="holiday_name"
              :reduce="option => option.id"
              :clearable="false"
            />
          </div>

          <div class="md:w-1/2 w-full p-1">
            <v-select
              class="w-full"
              placeholder="Set Room"
              v-model="room"
              :options="room_list"
              label="asset_name"
              :reduce="option => option.asset_id"
              :clearable="false"
              @open="onOpenRoomList"
              @close="onCloseRoomList"
            >
              <template #list-footer>
                <li ref="loadRooms" class="loader" v-show="room_list_meta.has_next">
                  Loading more rooms...
                </li>
              </template>
            </v-select>
          </div>

          <div class="w-full p-1">
            <vs-textarea
              class="w-full"
              placeholder="Enter Class Description"
              v-model="description"
            />
          </div>

          <div class="cstm_vuefileagent_holder w-full">
            <file-upload-component
              @deletedIndex="deleteUploadedFile"
              @getFileId="getFileId"
              :file_repository_id="repository_id"
              :files_info="files_info"
              acceptFiles="image/*"
              acceptGDriveFiles="photo"
            ></file-upload-component>
          </div>

        </div>

        <div class="flex flex-1 justify-end mt-8">
          <vs-button @click="createNewClass">Save</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import FileUploadComponent from './FileUploadComponent.vue'
import { repository } from '@/mixins/repository.js'
import vSelect from 'vue-select'
import { fetchHolidays } from '@/api/schedulerApi'
import { 
  getAllRooms, 
  createClass
} from '@/api/classes'

export default {
  name: 'BasicDetailsEditModal',
  mixins: [repository],
  props: ['open', 'basic_details', 'id_to_edit'],
  components: {
    flatPickr,
    FileUploadComponent,
    vSelect
  },
  data () {
    return {
      uploadedFiles: [],
      files_info: [],
      customer_id: null,
      user_id: null,
      class_name: '',
      class_capacity: '',
      term: '',
      class_start_date: null,
      class_end_date: null,
      description: '',
      holidays: [],
      holiday_list: [],
      room: null,
      room_list: [],
      room_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      room_list_observer: new IntersectionObserver(this.loadMoreRooms),
      teachers_list: [],
      selected_teachers_list: [],
      class_teacher: null,
      students_list: [],
      selected_students_list: [],
      mode: 'Edit',
      fpConfig: {
        altInput: true,
        altFormat: 'j F, Y',
        dateFormat: 'Y-m-d',
        minDate: new Date()
      }
    }
  },
  created () {
    //console.log('basic')
    this.customer_id = localStorage.getItem('customer_id')
    this.user_id = JSON.parse(localStorage.getItem('userInfo')).id

    this.getRepositoryId(49)
    this.getHolidayList()
    this.getRoomList()
  },
  watch: {

    basic_details:{
      deep:true,
      immediate:true,
      handler () {
        //console.log(this.basic_details)
        if (this.basic_details) {
          //console.log('hi')
          this.prepareForEdit()

        }
      }
    }
    
  },
  methods: {
    closeModal () {
      this.uploadedFiles = []
      this.class_name = ''
      this.class_capacity = ''
      this.term = ''
      this.class_start_date = null
      this.class_end_date = null
      this.description = ''
      this.holidays = []
      this.room = null
      this.teachers_list = []
      this.selected_teachers_list = []
      this.class_teacher = null
      this.students_list = []
      this.selected_students_list = []
      this.files_info = []
      

      this.$emit('close', false)
    },
    getFileId (file_id) {
      this.uploadedFiles = [file_id]
    },
    deleteUploadedFile (index) {
      this.uploadedFiles.splice(index, 1)
    },
    async getHolidayList () {
      try {
        const response = await fetchHolidays(this.user_id, this.customer_id)
        this.holiday_list = response.data.data.holiday
      } catch (e) {
        console.log(e)
      }
    },
    async onOpenRoomList () {
      if (this.room_list_meta.has_next) {
        await this.$nextTick()
        this.room_list_observer.observe(this.$refs.loadRooms)
      }
    },
    onCloseRoomList () {
      this.room_list_observer.disconnect()
    },
    async getRoomList () {
      try {
        const response = await getAllRooms(this.customer_id)
        this.room_list = response.data.data.assets
        this.room_list_meta = response.data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async loadMoreRooms ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const response = await getAllRooms(this.customer_id, this.room_list_meta.next_page_url)
          this.room_list.push(...response.data.data.assets)
          this.room_list_meta = response.data.data.meta
        } catch (e) {
          console.log(e)
        }
        
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async createNewClass () {
      const datesValid = this.$moment(this.class_end_date).isSameOrAfter(this.class_start_date)

      if (this.class_start_date && this.class_end_date && !datesValid) {
        this.showSuccessMessage('Warning', 'Class end date cannot be before class start date', 'warning')
        return
      }
      
      const payload = {
        customer_id: this.customer_id,
        name: this.class_name,
        capacity: this.class_capacity,
        term: this.term,
        start_date: this.class_start_date,
        end_date: this.class_end_date,
        description: this.description,
        holiday_id: this.holidays,
        class_teacher_id: this.class_teacher,
        file_id: this.uploadedFiles[0],
        asset_id: this.room,
        userArray: []
      }

      this.selected_teachers_list.map(teacher => {
        payload.userArray.push({ user_id: teacher.id, user_type: 1 })
      })

      this.selected_students_list.map(student => {
        payload.userArray.push({ user_id: student.id, user_type: 2 })
      })

      if (this.mode === 'Edit') {
        Object.assign(payload, { class_id:  this.id_to_edit })
      }

      if (this.class_name) {
        try {
          const response = await createClass(payload)

          if (this.mode === 'Edit') {
            this.$emit('on_data_updated', response.data.data.class)
            this.showSuccessMessage('Success', 'Class updated successfully', 'success')
          } else {
            this.$emit('on_data_added', response.data.data.class)
            this.showSuccessMessage('Success', 'Class created successfully', 'success')
          }

          this.closeModal()
        } catch (e) {
          this.showSuccessMessage('Error', e.data.message, 'danger')
          this.closeModal()
        }
      } else {
        this.showSuccessMessage('Warning', 'Class Name is required', 'warning')
      }
    },
    async prepareForEdit () {
      const { 
        name, 
        start_date, 
        end_date, 
        term, 
        holiday, 
        capacity, 
        description, 
        asset_id,
        student,
        teacher,
        class_teacher_details,
        file 
      } = this.basic_details
      
      this.class_name = name
      this.class_start_date = start_date
      this.class_end_date = end_date
      this.term = term
      this.class_capacity = capacity
      this.description = description
      this.room = asset_id
      this.class_teacher = class_teacher_details.id

      this.fpConfig.minDate = start_date

      if (file) {
        this.uploadedFiles.push(file.files_id)
        this.files_info.push(file)
      }

      this.selected_teachers_list = teacher.teacher_details.map(item => {
        return {
          id: item.id,
          first_name: item.first_name,
          middle_name: item.middle_name,
          last_name: item.last_name,
          email: item.email,
          phone: item.phone,
          role_name: item.role_name,
          full_name: `${item.first_name} ${item.middle_name} ${item.last_name}`
        }
      })

      this.selected_students_list = student.student_details.map(item => {
        return {
          ...item,
          full_name: `${item.first_name} ${item.middle_name} ${item.last_name}`
        }
      })

      holiday.map(item => {
        this.holidays.push(item.id)
      })
    }
  }
}
</script>

<style scoped>
  .loader {
    text-align: center;
    color: #bbbbbb;
  }
</style>
<style>
.class_setting_collapse .vs-collapse-item.open-item .vs-collapse-item--content {
  overflow: unset;
}
</style>